import React from 'react';
import '../styles/AdminNotifications.css';

const AdminNotifications = ({
  bigGameAnnouncement,
  adminNotification,
  onDismissBigGame,
  onDismissNotification
}) => {

  return (
    <div className="admin-notifications">
      {/* Big Game Announcement */}
      {bigGameAnnouncement && (
        <div className="big-game-announcement">
          <div className="announcement-header">
            <h2>🎮 {bigGameAnnouncement.gameName}</h2>
            <button 
              className="dismiss-button"
              onClick={onDismissBigGame}
              aria-label="Dismiss announcement"
            >
              ✕
            </button>
          </div>
          <div className="announcement-content">
            <p>{bigGameAnnouncement.announcement}</p>
            {bigGameAnnouncement.tradingPaused && (
              <div className="trading-notice">
                ⚠️ Trading has been paused for this game
              </div>
            )}
          </div>
          <div className="announcement-time">
            {new Date(bigGameAnnouncement.timestamp).toLocaleTimeString()}
          </div>
        </div>
      )}

      {/* Admin Notifications */}
      {adminNotification && (
        <div className={`admin-notification ${adminNotification.type.toLowerCase()}`}>
          <div className="notification-content">
            <div className="notification-icon">
              {getNotificationIcon(adminNotification.type)}
            </div>
            <div className="notification-text">
              <div className="notification-message">
                {adminNotification.message}
              </div>
              <div className="notification-time">
                {new Date(adminNotification.timestamp).toLocaleTimeString()}
              </div>
            </div>
            <button 
              className="dismiss-button"
              onClick={onDismissNotification}
              aria-label="Dismiss notification"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const getNotificationIcon = (type) => {
  switch (type) {
    case 'OPENING_BELL':
      return '🔔';
    case 'CLOSING_BELL':
      return '🔔';
    case 'TRADING_RESUMED':
      return '📈';
    case 'ADMIN_BALANCE_UPDATE':
      return '💰';
    default:
      return '📢';
  }
};

export default AdminNotifications;